import { useNavigate } from 'react-router-dom';
import { usePeople } from '../hooks/hooks_index';
import { Loading, MediaImageLoading } from "../components/components_index";
import { useState, useRef, useEffect, useMemo } from 'react';
import '../styles/Directory.css';

export default function Directory() {
  const {data: people, isLoading, error} = usePeople();
  const navigate = useNavigate();
  // const [visiblePeople, setVisiblePeople] = useState([]);
  const [directoryList, setDirectoryList] = useState(null);
  const [query, setQuery] = useState("");

  const peopleList = useMemo(() => (people ? Object.entries(people) : []), [people]);

  useEffect(() => {
    if (!people) return;
    async function fetchDirectory() {
      const directory = await Promise.all(
        peopleList
          .filter(([id]) => !id.startsWith("P0"))
          .map(async ([id, person]) => {  
            return {
              id,
              name: person.AKA || `${person.f_name} ${person.l_name}`,
              img: person.profile_pic ?? "S_logo_PNG.png",
              children: Array.isArray(person.children) ? person.children : [],
              parents: {father: person.parents?.f_id ?? null, mother: person.parents?.m_id ?? null},
              b_details: {
                b_year: person.b_details?.b_year ?? null,
                b_month: person.b_details?.b_month ?? null,
                b_day: person.b_details?.b_day ?? null
              },
              d_details: {
                d_year: person.d_details?.d_year ?? null,
                d_month: person.d_details?.d_month ?? null,
                d_day: person.d_details?.d_day ?? null
              },
              spouses: Array.isArray(person.m_details)
                ? person.m_details.map(m => ({
                  id: m.spouse,
                  married: m.m_year ?? null,
                  divorced: m.div_year ?? null
                })) 
                : []
            };
          })
      );
      setDirectoryList(directory);
    }
    fetchDirectory();
  }, [peopleList, people]);

  const visiblePeople = useMemo(() => {
    if (!directoryList) return [];
   
    let filtered = directoryList;
    if (query) {
      filtered = directoryList.filter(person =>
        person.name.toLowerCase().includes(query.toLowerCase())
      );
    }

    return [...filtered].sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }, [directoryList, query]);

  if (isLoading) return <Loading/>;
  if (error) return <div>Error loading people</div>;

  return (
    <div className='directory-page'>
      <div className="page-title">Family Directory</div>
      <SearchBar query={query} setQuery={setQuery} />
      <div className='directory-container'>
        <div className='directory-list'>
          {visiblePeople.map((person) => (
            <div 
              className='directory-item' 
              key={person.id} 
              onClick={() => navigate(`/people/${person.id}`)}
              title={`Visit ${person.name.split(' ')[0]}'s page`}  
            >
              <MediaImageLoading src={person.img} className={`directory-image`} containerName={'directory'}/>
              <div className="directory-subtext">
                {person.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function SearchBar({ query, setQuery }) {
  const wrapperRef = useRef(null);

  function handleChange(e) {
    setQuery(e.target.value);
  }

  function handleKeyPress(e) {
    if (e.key === "Escape") {
      setQuery("");
      e.target.blur();
    }
  }

  return (
    <div className='directory-search-wrapper' ref={wrapperRef}>
      <input 
        id='search-field'
        type='text'
        placeholder='Search directory'
        value={query}
        onChange={handleChange}
        onKeyDown={handleKeyPress}
        autoComplete='off'
      />
      <button onClick={() => setQuery("")}>Clear Search</button>
    </div>
  );
}
